/*
 * ATLAS COD form — test build for Noorwall.
 * Same blocks as the current Releasit form, and every order carries where the buyer came from.
 */
(() => {
  'use strict';
  if (window.__acodLoaded) return;
  window.__acodLoaded = true;

  const CFG = window.ATLAS_COD || {};
  if (!CFG.endpoint) return;

  const T = {
    buy: 'Achetez avec paiement à la livraison',
    header: 'Commande avec paiement à la livraison',
    subtotal: 'Sous-total',
    shipping: 'Livraison',
    total: 'Total',
    free: 'Gratuit',
    shipTitle: 'Mode de livraison',
    shipRate: 'Livraison gratuite',
    customText: 'Insérez votre adresse de livraison',
    name: 'Nom Complet',
    phone: 'Téléphone',
    address: 'Adresse',
    city: 'Ville',
    newsletter: 'Inscrivez-vous pour recevoir des communications sur les nouveaux produits et offres !',
    submit: 'Terminez votre achat - ',
    whatsapp: 'Acheter sur WhatsApp',
    required: 'Ce champ est requis.',
    invalid: 'Entrez une valeur valide.',
    invalidPhone: 'Insérez un numéro de téléphone valide.',
    error: "La commande n'a pas pu être envoyée. Réessayez, ou commandez sur WhatsApp.",
    sending: 'Envoi de la commande…',
    close: 'Fermer',
    waMessage: "Bonjour! Je souhaite acheter ce produit : {page_url}" + String.fromCharCode(10) + "Pouvez-vous m'aider?",
  };

  // Noorwall's own thank-you message, as configured today
  const THANKS = '<div style="max-width:600px;margin:40px auto;padding:30px;text-align:center;font-family:Arial,Helvetica,sans-serif;background:#ffffff;border-radius:12px;box-shadow:0 8px 25px rgba(0,0,0,0.08);">'
    + '<div style="font-size:50px;margin-bottom:15px;">✅</div>'
    + '<h1 style="font-size:24px;margin:0 0 15px;color:#222;">Merci, votre commande est bien reçue.</h1>'
    + '<div style="width:60px;height:3px;background:#2ecc71;margin:0 auto 20px;">&nbsp;</div>'
    + '<p style="font-size:15px;color:#555;margin:0 0 10px;line-height:1.6;">Un conseiller vous contactera dans les prochaines heures pour confirmer votre commande.</p>'
    + '<p style="font-size:14px;color:#777;margin:0;line-height:1.6;">Merci de répondre à l’appel ou au message afin de valider définitivement votre commande.</p>'
    + '<div style="margin-top:25px;font-size:13px;color:#999;">📞 Service client &nbsp;|&nbsp; Confirmation rapide</div>'
    + '</div>';

  const ICON = {
    cart: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M7 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm10 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM3 3h2.2l2.6 10.4A2 2 0 0 0 9.7 15h7.6a2 2 0 0 0 1.9-1.4L21 7H7.1l-.5-2A2.6 2.6 0 0 0 4.2 3H3z"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" d="M6 6l12 12M18 6L6 18"/></svg>',
    person: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zm0 2c-4.4 0-8 2.2-8 5v2h16v-2c0-2.8-3.6-5-8-5z"/></svg>',
    phone: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M6.6 10.8a15.1 15.1 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.25c1.1.37 2.3.57 3.6.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1z"/></svg>',
    pin: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"/></svg>',
    wa: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.8" d="M12 2.8a9.2 9.2 0 0 0-7.9 13.9L3 21l4.4-1.1A9.2 9.2 0 1 0 12 2.8z"/><path fill="currentColor" d="M8.6 7.4c.25-.5.5-.5.85-.5h.55c.2 0 .4.08.5.35l.75 1.8c.08.25 0 .45-.12.62l-.55.66a7.1 7.1 0 0 0 2.95 2.95l.66-.55c.17-.14.4-.2.62-.12l1.8.75c.27.1.35.3.35.5v.55c0 .35 0 .6-.5.85-.65.35-1.8.55-3.2-.1a8.7 8.7 0 0 1-4.3-4.3c-.65-1.4-.45-2.55-.36-3.36z"/></svg>',
  };

  const FIELDS = [
    { key: 'name', label: T.name, icon: 'person', type: 'text', autocomplete: 'name', min: 2, max: 250 },
    { key: 'phone', label: T.phone, icon: 'phone', type: 'tel', autocomplete: 'tel', inputmode: 'tel', max: 20 },
    { key: 'address', label: T.address, icon: 'pin', type: 'text', autocomplete: 'street-address', min: 2, max: 250 },
    { key: 'city', label: T.city, icon: 'pin', type: 'text', autocomplete: 'address-level2', min: 2, max: 250 },
  ];

  const state = { items: [], context: 'product', openedAt: 0, busy: false, waSent: false };
  let modal = null;
  let lastTrigger = null;

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const fixUrl = (u) => (!u ? '' : String(u).startsWith('//') ? 'https:' + u : String(u));
  const subtotal = () => state.items.reduce((sum, i) => sum + i.price * i.quantity, 0);

  function money(cents) {
    const amount = (cents / 100).toFixed(2);
    const fmt = CFG.moneyFormat || '{{amount}} dh';
    return fmt.replace(/<[^>]*>/g, '').replace(/[{][{] *([a-z_]+) *[}][}]/, (_, k) => {
      if (k === 'amount_no_decimals') return String(Math.round(cents / 100));
      if (k === 'amount_with_comma_separator') return amount.replace('.', ',');
      return amount;
    });
  }

  // Moroccan mobile and landline numbers, in every format customers actually type
  function normPhone(raw) {
    const d = String(raw || '').replace(/[^0-9]/g, '');
    if (/^212[5-8][0-9]{8}$/.test(d)) return '+' + d;
    if (/^00212[5-8][0-9]{8}$/.test(d)) return '+' + d.slice(2);
    if (/^0[5-8][0-9]{8}$/.test(d)) return '+212' + d.slice(1);
    if (/^[5-8][0-9]{8}$/.test(d)) return '+212' + d;
    return null;
  }

  // ---------- cart contents ----------
  function currentVariantId() {
    const scope = document.querySelector('.t4s-form__product') || document;
    const input = scope.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    const fromForm = input && Number(input.value);
    if (fromForm) return fromForm;
    const m = location.search.match(/[?&]variant=([0-9]+)/);
    return m ? Number(m[1]) : CFG.product && CFG.product.selectedVariantId;
  }

  function currentQuantity() {
    const q = document.querySelector('.t4s-form__product [name="quantity"], form[action*="/cart/add"] [name="quantity"]');
    const n = q ? parseInt(q.value, 10) : 1;
    return n > 0 && n <= 50 ? n : 1;
  }

  function productItems() {
    const p = CFG.product;
    if (!p || !p.variants || !p.variants.length) return [];
    const id = currentVariantId();
    const v = p.variants.find((x) => x.id === id) || p.variants[0];
    return [{
      productId: p.id,
      variantId: v.id,
      quantity: currentQuantity(),
      title: p.title,
      variantTitle: v.title === 'Default Title' ? '' : v.title,
      price: v.price,
      image: fixUrl(v.image || p.image),
      url: p.url,
    }];
  }

  async function cartItems() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await res.json();
    return (cart.items || []).map((i) => ({
      productId: i.product_id,
      variantId: i.variant_id,
      quantity: i.quantity,
      title: i.product_title,
      variantTitle: i.variant_title || '',
      price: i.final_price,
      image: fixUrl(i.image),
      url: i.url,
    }));
  }

  // ---------- modal ----------
  const fieldHtml = (f) => `
    <div class="acod-row" data-key="${f.key}">
      <div class="acod-field">
        <label class="acod-label" for="acod-${f.key}">${esc(f.label)}<i aria-hidden="true">*</i></label>
        <div class="acod-control">
          <span class="acod-icon">${ICON[f.icon]}</span>
          <input class="acod-input" id="acod-${f.key}" name="${f.key}" type="${f.type}" placeholder="${esc(f.label)}"
            autocomplete="${f.autocomplete}"${f.inputmode ? ` inputmode="${f.inputmode}"` : ''} maxlength="${f.max}"
            required aria-describedby="acod-${f.key}-err">
        </div>
      </div>
      <div class="acod-err" id="acod-${f.key}-err"></div>
    </div>`;

  function build() {
    modal = document.createElement('div');
    modal.className = 'acod-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'acod-title');
    modal.innerHTML = `
      <div class="acod-container">
        <form class="acod-form" novalidate autocomplete="on">
          <div class="acod-header">
            <h2 class="acod-title" id="acod-title">${esc(T.header)}</h2>
            <button type="button" class="acod-close" aria-label="${esc(T.close)}">${ICON.close}</button>
          </div>
          <div class="acod-body">
            <div class="acod-lines"></div>
            <div class="acod-totals"></div>
            <span class="acod-ship-title">${esc(T.shipTitle)}</span>
            <div class="acod-ship"><span class="acod-radio" aria-hidden="true"></span><span class="acod-ship-name">${esc(T.shipRate)}</span><b>${esc(T.free)}</b></div>
            <div class="acod-custom">${esc(T.customText)}</div>
            ${FIELDS.map(fieldHtml).join('')}
            <label class="acod-check"><input type="checkbox" name="newsletter" id="acod-newsletter"><span>${esc(T.newsletter)}</span></label>
            <input class="acod-hp" type="text" name="company" tabindex="-1" autocomplete="off" aria-hidden="true">
            <div class="acod-alert" role="alert" hidden></div>
            <button type="submit" class="acod-submit"></button>
            <a class="acod-wa" target="_blank" rel="noopener">${ICON.wa}<span>${esc(T.whatsapp)}</span></a>
          </div>
        </form>
      </div>`;
    document.body.appendChild(modal);

    const form = modal.querySelector('form');
    modal.addEventListener('click', (e) => {
      if (e.target === modal || e.target.classList.contains('acod-container')) close();
    });
    modal.querySelector('.acod-close').addEventListener('click', close);
    form.addEventListener('submit', onSubmit);
    modal.querySelector('.acod-wa').addEventListener('click', onWhatsApp);
    FIELDS.forEach((f) => {
      const input = form.elements[f.key];
      input.addEventListener('blur', () => { if (input.value) validate(f); });
      input.addEventListener('input', () => {
        if (window.AtlasPixels) window.AtlasPixels.infoFilled();
        if (row(f).classList.contains('is-invalid')) validate(f);
      });
    });
  }

  const formEl = () => modal.querySelector('form');
  const row = (f) => formEl().querySelector(`.acod-row[data-key="${f.key}"]`);

  function validate(f) {
    const input = formEl().elements[f.key];
    const v = input.value.trim();
    let msg = '';
    if (!v) msg = T.required;
    else if (f.key === 'phone') msg = normPhone(v) ? '' : T.invalidPhone;
    else if (v.length < (f.min || 1)) msg = T.invalid;
    const r = row(f);
    r.classList.toggle('is-invalid', Boolean(msg));
    r.querySelector('.acod-err').textContent = msg;
    input.setAttribute('aria-invalid', msg ? 'true' : 'false');
    return !msg;
  }

  function waUrl() {
    const msg = T.waMessage.replace('{page_url}', location.origin + location.pathname);
    return `https://api.whatsapp.com/send/?phone=${encodeURIComponent(CFG.whatsapp || '')}&text=${encodeURIComponent(msg)}`;
  }

  function submitLabel() {
    return `<span>${esc(T.submit)}${esc(money(subtotal()))}</span>`;
  }

  function render() {
    modal.querySelector('.acod-lines').innerHTML = state.items.map((i) => `
      <div class="acod-line">
        <div class="acod-thumb">${i.image ? `<img src="${esc(i.image)}" alt="" width="63" height="63">` : ''}<span class="acod-qty">${i.quantity}</span></div>
        <div class="acod-info"><a class="acod-name" href="${esc(i.url || '#')}">${esc(i.title)}</a>${i.variantTitle ? `<span class="acod-variant">${esc(i.variantTitle)}</span>` : ''}</div>
        <div class="acod-price">${esc(money(i.price * i.quantity))}</div>
      </div>`).join('');
    const sub = money(subtotal());
    modal.querySelector('.acod-totals').innerHTML = `
      <div class="acod-tl"><span>${esc(T.subtotal)}</span><b>${esc(sub)}</b></div>
      <div class="acod-tl"><span>${esc(T.shipping)}</span><b>${esc(T.free)}</b></div>
      <div class="acod-tl is-total"><span>${esc(T.total)}</span><span class="acod-tv">${esc(sub)}</span></div>`;
    modal.querySelector('.acod-submit').innerHTML = submitLabel();
    modal.querySelector('.acod-wa').href = waUrl();
  }

  async function open(context) {
    if (modal && modal.dataset.done) {
      modal.remove();
      modal = null;
    }
    if (!modal) build();
    state.context = context;
    try {
      state.items = context === 'cart' ? await cartItems() : productItems();
    } catch (e) {
      state.items = [];
    }
    if (!state.items.length) return;
    state.openedAt = Date.now();
    state.waSent = false;
    hideAlert();
    render();
    modal.classList.add('is-open');
    document.documentElement.classList.add('acod-lock');
    modal.querySelector('.acod-close').focus({ preventScroll: true });
    if (window.AtlasPixels) window.AtlasPixels.initiateCheckout(state.items, CFG.currency || 'MAD');
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('acod-lock');
    if (lastTrigger) lastTrigger.focus({ preventScroll: true });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) close();
  });

  function showAlert(text) {
    const box = modal.querySelector('.acod-alert');
    box.textContent = text;
    box.hidden = false;
  }
  function hideAlert() {
    const box = modal && modal.querySelector('.acod-alert');
    if (box) box.hidden = true;
  }

  function setLoading(on) {
    const btn = modal.querySelector('.acod-submit');
    btn.disabled = on;
    btn.innerHTML = on ? `<span class="acod-spin" aria-hidden="true"></span><span class="acod-sr">${esc(T.sending)}</span>` : submitLabel();
  }

  function payload(mode) {
    const form = formEl();
    const val = (k) => (form.elements[k] ? form.elements[k].value.trim() : '');
    return {
      mode,
      context: state.context,
      items: state.items.map((i) => ({ variantId: i.variantId, quantity: i.quantity })),
      fields: { name: val('name'), phone: val('phone'), address: val('address'), city: val('city') },
      newsletter: Boolean(form.elements.newsletter && form.elements.newsletter.checked),
      source: window.AtlasSource ? window.AtlasSource.get() : null,
      page: location.href.slice(0, 500),
      openedMs: Date.now() - state.openedAt,
      company: val('company'),
    };
  }

  // text/plain keeps this a "simple" request: no CORS preflight, and it survives page unload
  async function send(mode, keepalive) {
    const res = await fetch(CFG.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(payload(mode)),
      keepalive: Boolean(keepalive),
      credentials: 'omit',
    });
    return res.json().catch(() => null);
  }

  async function onSubmit(e) {
    e.preventDefault();
    if (state.busy) return;
    const ok = FIELDS.map(validate).every(Boolean);
    if (!ok) {
      const bad = formEl().querySelector('.acod-row.is-invalid .acod-input');
      if (bad) bad.focus();
      return;
    }
    state.busy = true;
    hideAlert();
    setLoading(true);
    try {
      const result = await send('form');
      if (!result || !result.ok) throw new Error((result && result.error) || 'failed');
      await onSuccess(result);
    } catch (err) {
      setLoading(false);
      showAlert(T.error);
    } finally {
      state.busy = false;
    }
  }

  // Real orders go to the thank-you page, where the Purchase pixels fire once
  async function onSuccess(result) {
    try {
      const order = result && result.order;
      const pix = window.AtlasPixels;
      if (state.context === 'cart') await fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' }).catch(() => {});
      if (order && CFG.thankYouUrl) {
        const phoneInput = formEl().elements.phone;
        const data = pix ? pix.buildPurchase(order, state.items, result.currency || CFG.currency || 'MAD', normPhone(phoneInput ? phoneInput.value : '')) : null;
        const stored = data ? pix.store(data) : false;
        if (data && !stored) pix.purchase(data);
        const go = () => { location.href = CFG.thankYouUrl + '?commande=' + encodeURIComponent(String(order.name || '').replace('#', '')); };
        if (data && !stored) setTimeout(go, 800);
        else go();
        return;
      }
      if (order && pix) pix.purchase(pix.buildPurchase(order, state.items, result.currency || CFG.currency || 'MAD', ''));
    } catch (e) { /* the order exists: never show an error from here */ }
    modal.querySelector('.acod-body').innerHTML = THANKS;
    modal.dataset.done = '1';
    modal.scrollTop = 0;
  }

  // Releasit also creates an order when WhatsApp is chosen, so the lead is never lost
  function onWhatsApp() {
    if (state.waSent) return;
    state.waSent = true;
    if (window.AtlasPixels) window.AtlasPixels.whatsappClick();
    send('whatsapp', true).catch(() => {});
  }

  // ---------- buttons ----------
  function buyButton(context) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'acod-buy';
    b.innerHTML = `${ICON.cart}<span>${esc(T.buy)}</span>`;
    b.addEventListener('click', (e) => {
      e.preventDefault();
      lastTrigger = b;
      open(context);
    });
    return b;
  }

  function mountProduct() {
    if (!CFG.product) return;
    const holder = document.querySelector('.t4s-form__product .t4s-product-form__buttons') || document.querySelector('form[action*="/cart/add"]');
    if (!holder || holder.querySelector('.acod-buy')) return;
    const main = buyButton('product');
    holder.appendChild(main);
    let bar = document.querySelector('.acod-float');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'acod-float';
      bar.appendChild(buyButton('product'));
      document.body.appendChild(bar);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => bar.classList.toggle('is-visible', !entries[0].isIntersecting)).observe(main);
    }
  }

  function mountCart() {
    if (!/^[/]cart[/]?$/.test(location.pathname)) return;
    const checkout = document.querySelector('button[name="checkout"], input[name="checkout"]');
    if (!checkout || document.querySelector('.acod-buy[data-context="cart"]')) return;
    const b = buyButton('cart');
    b.dataset.context = 'cart';
    checkout.insertAdjacentElement('afterend', b);
  }

  function mount() {
    mountProduct();
    mountCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();

  // The theme re-renders its buy box on variant changes: put the button back if it disappears
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      mount();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
